module.exports = "<svg height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\"><path d=\"M42.5 22h-25c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM17.5 16h10c.55 0 1-.45 1-1s-.45-1-1-1h-10c-.55 0-1 .45-1 1s.45 1 1 1zM42.5 30h-25c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM42.5 38h-25c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1zM42.5 46h-25c-.55 0-1 .45-1 1s.45 1 1 1h25c.55 0 1-.45 1-1s-.45-1-1-1z\"/><path d=\"M38.9 0H6.5v60h47V14.6L38.9 0zm.6 3.4L50.1 14H39.5V3.4zM8.5 58V2h29v14h14v42h-43z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/file.svg
// module id = ./src/icons/file.svg
// module chunks = 21